module.exports = __webpack_public_path__ + "static/media/S41.06f7afed.png";